<template>
    <div class="swipe-warper">
        <van-swipe :autoplay="3000" :height="150">
            <van-swipe-item v-for="(image, index) in images" :key="index" >
                <van-image radius="10" height="150" :src="image" />
            </van-swipe-item>
        </van-swipe>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { Swipe, SwipeItem } from 'vant';
    import {Lazyload} from 'vant';
    import { Image as VanImage } from 'vant';
    Vue.use(Lazyload)
    export default {
        name: "SwipeImage",
        components:{
            [Swipe.name]:Swipe,
            [SwipeItem.name]:SwipeItem,
            [VanImage.name]: VanImage,

        },
        data() {
            return {
                lazyComponent: true,
                images: [
                    'https://dzycsys-1258740428.cos.ap-shanghai.myqcloud.com/img/20220225143132.jpg',
                    'https://dzycsys-1258740428.cos.ap-shanghai.myqcloud.com/img/20220225143139.jpg',
                    // 'https://img.yzcdn.cn/vant/apple-3.jpg',
                    // 'https://img.yzcdn.cn/vant/apple-4.jpg',
                ],
            };
        },
    }
</script>

<style scoped>
    .swipe-warper{
        width:95%;
        margin:10px auto 0 auto;
    }
    .my-swipe .van-swipe-item {
        color: #fff;
        font-size: 20px;
        line-height: 150px;
        text-align: center;
        background-color: #39a9ed;
    }

    van-swipe{
        height: 150px;
    }
</style>
